module.exports = __webpack_public_path__ + "img/dynamic-7.db3b3deb.png";